/**
 *
 * ExplorePackagesBanner
 *
 */

import React from 'react';
import styled, { css } from 'styled-components';
import NewText from 'Components/NewText';
import Button from 'Components/Button';
import Icon from 'Components/Icon';

const getExploreUrl = () => {
  const countryCode = process.env.REACT_APP_COUNTRY;
  const urls = {
    UY: 'https://explora.mevuelo.com.uy/',
    PY: 'https://explora.mevuelo.com.py/',
    CO: 'https://explora.mevuelo.com.co/',
    BO: 'https://explora.mevuelo.com.bo/'
  };
  return urls[countryCode] || null;
};

export const ExplorePackagesBanner = () => {
  const exploreUrl = getExploreUrl();

  if (!exploreUrl) {
    return null;
  }

  const handleClick = () => {
    window.open(exploreUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <PromoBanner>
      <Container onClick={handleClick}>
        <ContentWrapper>
          <Icon name="mv-packages" size={32} color="white" />
          <TextWrapper>
            <NewText fontSize="18px" fontWeight="bold" color="white">
              ¡Descubrí nuestra nueva experiencia!
            </NewText>
            <NewText fontSize="14px" color="white">
              Explorá paquetes de una forma más fácil e intuitiva
            </NewText>
          </TextWrapper>
        </ContentWrapper>
        <Button className="explorar-btn">
          <ButtonLabel>Explorar</ButtonLabel>
          <Icon name="mv-arrow-right" size={15} color="white" />
        </Button>
      </Container>
    </PromoBanner>
  );
};

const PromoBanner = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.three};
    margin-top: ${theme.spacing.three};
  `}
`;

const ButtonLabel = styled.span`
  white-space: nowrap;
  margin-right: ${({ theme }) => theme.spacing.one};
`;

const Container = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.three};
    margin-top: ${theme.spacing.three};
    background: ${theme.palette.gradients.orange(135)};
    border-radius: ${theme.borderRadius.default};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: ${theme.spacing.four};
    max-width: 1100px;
    margin: auto;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    @media screen and (max-width: 767px) {
      position: relative;
      max-width: 100%;
      margin-bottom: ${theme.spacing.three};
      margin-top: ${theme.spacing.three};
      padding: ${theme.spacing.three} ${theme.spacing.four};
      .explorar-btn {
        display: none;
      }
    }
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.two};
  flex: 1;

  @media screen and (max-width: 767px) {
    gap: ${({ theme }) => theme.spacing.three};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.one};

  @media screen and (max-width: 767px) {
    gap: 2px;

    span:first-child {
      font-size: 16px;
      line-height: 19px;
    }

    span:last-child {
      font-size: 13px;
      line-height: 17px;
    }
  }
`;
